import React from 'react';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import BasicError from './BasicError';
import useIsMobile from '../hooks/useIsMobile';
import { useThemeCustomStyles } from '../hooks/useThemeConfig';
import InputLabel from './InputLabel';

function InputField({ control, handleChange, showValidation }) {
  const small = useIsMobile();
  const styles = useThemeCustomStyles();
  const inputStyle = styles.InputField.input(small);
  const { validation } = control;
  return (
	<Stack spacing={1} sx={{ height: '100%' }} >
		<InputLabel title={control.title} />		
	    <TextField color="primary" 
			size={small ? 'small' : 'medium'}
			id={control.id} 
			variant="outlined" 
			value={control.data} 
			onChange={handleChange}
			sx={inputStyle} 
		/>
		{showValidation && !validation.valid && (<BasicError error={validation.text} />)}
	</Stack>
  );
}

export default InputField;
